module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('error-page', {
    attrs: {
      "error": "404"
    }
  })
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-33468a71!./~/vue-loader/lib/selector.js?type=template&index=0!./src/NotFound.vue
 ** module id = 794
 ** module chunks = 1
 **/